import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastType } from './toast.component.types';

@Component({
  selector: 'ef-toast',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  public readonly title = input<string>('');
  public readonly description = input<string>('');
  public readonly type = input<ToastType>('default');
  public readonly onHide = output();

  public hide(): void {
    this.onHide.emit();
  }
}
